var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOintment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1169_54352)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7643 10.5003L9.69286 19.1133L4.39453 13.0825L14.4082 2.12728",
    stroke: "#737373",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1169_54352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1169_54352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1318 2.99017L13.8398 1.48249L15.1165 0.351345L23.6085 10.0173L22.3319 11.1484L16.3039 4.28716",
    stroke: "#737373",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14258 16.7763L6.01134 18.9034L9.69206 19.1133L4.39373 13.0825L4.14258 16.7763Z",
    stroke: "#737373",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77051 18.8807L3.63927 21.0078L6.01148 18.906L4.14271 16.7789L1.77051 18.8807Z",
    stroke: "#737373",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08976 20.2617L2.64551 17.4795",
    stroke: "#737373",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5513 9.40906L12.6148 10.2493L11.7761 9.31456L10.7687 10.2223L11.6074 11.1571L10.6709 11.9974L11.5772 13.0032L12.5137 12.1629L13.3524 13.0977L14.3598 12.1899L13.5211 11.2551L14.4576 10.4149L13.5513 9.40906Z",
    stroke: "#737373",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1169_54352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.43051e-06H24V24H0V1.43051e-06Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1169_54352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2096 8.88331C16.4989 10.3401 16.36 12.5626 14.8994 13.8473C13.4387 15.1321 11.2094 14.9925 9.92011 13.5357C8.63076 12.0789 8.7697 9.85644 10.2303 8.57169C11.691 7.28694 13.9203 7.42649 15.2096 8.88331Z",
    stroke: "#737373",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64828 21.9106C7.09164 21.5357 6.3033 21.1493 5.12073 21.5298C3.39827 22.0843 3.08397 21.1123 3.33077 20.6556L2.25438 19.4304C-0.581655 20.2221 0.0943758 23.6468 2.44867 23.6468C3.49628 23.6468 4.11916 23.3714 4.69858 23.1768C6.10338 22.7052 7.04814 23.6043 8.383 23.6468C10.0803 23.7007 10.3922 22.4287 10.3922 22.4287C10.3922 22.4287 9.65739 22.7007 8.84973 22.5318",
    stroke: "#737373",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1169_54352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOintment);
export default __webpack_public_path__ + "static/media/ointment.67dceb9c56bd6d0f0116ba91c15418d4.svg";
export { ForwardRef as ReactComponent };